export const formatNumberEng = (amount, index) => {
  let formattedNumber = amount
  let suffix = ''

  if (amount >= 1e9) {
    suffix = 'B'
    formattedNumber = amount / 1e9
  } else if (amount >= 1e6) {
    suffix = 'M'
    formattedNumber = amount / 1e6
  } else if (amount >= 1e3) {
    suffix = 'K'
    formattedNumber = amount / 1e3
  }

  let result = formattedNumber.toFixed(index)

  if (result.endsWith(',0')) {
    result = result.slice(0, -2)
  }

  return `${result}${suffix}`
}

export function formatUnixToDate(timestamp) {
  const date = new Date(timestamp * 1000)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}
